import { AnimationDuration } from "@uno/protocol";
import { AnimationValue } from "../types/Animation";
import { computeDeckToHandEffects } from "./utils";
import { getRoomLayoutSnapshot } from "utils/RoomLayout";

const DrawCardFromDeckAnimation = (isMe: boolean, order: number = 0): AnimationValue => {
    const { scales, deckRotation } = getRoomLayoutSnapshot();
    const targetScale = isMe ? scales.hand : scales.opponent;
    const delay = order * AnimationDuration.DrawCardStagger;

    return {
        duration: delay + AnimationDuration.DrawCardFromDeck,
        effects: (el: HTMLElement) => {
            return computeDeckToHandEffects(el, deckRotation, targetScale) ?? [];
        },
        transitions: [{
            delay,
            duration: AnimationDuration.DrawCardFromDeck,
            fill: "backwards",
            easing: isMe ? "ease-in-out" : "ease-out",
        }],
    };
};

export default DrawCardFromDeckAnimation;
